'use client';

import { TooltipProvider } from '@/components/ui/tooltip';
import { AnalyticsProvider } from '@/contexts/AnalyticsContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { StreamChatProvider } from '@/contexts/StreamChatContext';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <AnalyticsProvider>
        <StreamChatProvider>
          <TooltipProvider delayDuration={300}>{children}</TooltipProvider>
        </StreamChatProvider>
      </AnalyticsProvider>
    </AuthProvider>
  );
}
